import React from 'react'

import { camelCaseToSenteseCase } from 'src/utils/helpers'
import { Text } from '@chakra-ui/react'
import styles from '../styles.module.less'
import intlMessages from 'src/modules/Claims/translations'
import intlMessagesLocation from 'src/modules/Claims/Location/translations'
import intlMessagesClaimDrivers from 'src/modules/Claims/Drivers/translations'
import intlMessagesClaimOther from 'src/modules/Claims/OtherVehicleAndDriver/translations'
import intlMessagesClaimInvestigatingOfficer from 'src/modules/Claims/InvestigatingOfficer/translations'

export default function ReviewItem({ intl, title, subtitle, data, renderBelow }) {
  return (
    <div className={styles.reviewWrapper}>
      <Text
        variant='secondary'
        fontWeight={'bold'}
        fontSize={'16px'}
        className={styles.reviewHeadline}
      >
        {title}
      </Text>
      <Text
        variant='secondary'
        fontSize={'16px'}
        display-if={subtitle}
        className={styles.reviewItem}
      >
        {subtitle}
      </Text>
      {data
        ? Object.keys(data).map(key => {
            if (!data[key] || key === 'space') {
              return <Text variant='secondary' fontSize={'16px'} key={key} />
            }

            let label = ''
            switch (key) {
              case 'name':
                label = intl.formatMessage(intlMessages.claimsName)
                break
              case 'description':
                label = intl.formatMessage(intlMessages.claimsDescription)
                break
              case 'locationText':
                label = intl.formatMessage(intlMessages.claimsLocation)
                break
              case 'address':
                label = intl.formatMessage(intlMessagesLocation.locationPlaceholderAddress)
                break
              case 'firstName':
                label = intl.formatMessage(intlMessagesClaimDrivers.placeholderFirstName)
                break
              case 'lastName':
                label = intl.formatMessage(intlMessagesClaimDrivers.placeholderLastName)
                break
              case 'policy':
                label = intl.formatMessage(intlMessagesClaimDrivers.placeholderPolicy)
                break
              case 'driverLicense':
                label = intl.formatMessage(intlMessagesClaimDrivers.placeholderDriverLicense)
                break
              case 'owner':
                label = intl.formatMessage(intlMessagesClaimOther.claimsOtherOwnerOfVehicleSwitch)
                break
              case 'make':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderMake)
                break
              case 'model':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderModel)
                break
              case 'color':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderColor)
                break
              case 'year':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderYear)
                break
              case 'insuranceCompany':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderInsuranceCompany)
                break
              case 'licensePlate':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderLicensePlate)
                break
              case 'phone':
                label = intl.formatMessage(intlMessagesClaimOther.placeholderPhone)
                break
              case 'badge':
                label = intl.formatMessage(intlMessagesClaimInvestigatingOfficer.placeholderBadge)
                break
              case 'division':
                label = intl.formatMessage(
                  intlMessagesClaimInvestigatingOfficer.placeholderDivision,
                )
                break
              case 'date':
                label = ''
                break
              default:
                label = camelCaseToSenteseCase(key)
            }

            return (
              <Text variant='secondary' fontSize={'13px'} key={key} className={styles.reviewItem}>
                <span>{label ? label + ':' : ''}</span> {data[key]}
              </Text>
            )
          })
        : ''}

      {renderBelow && typeof renderBelow === 'function' ? (
        <div className={styles.reviewItemContentBelow}>{renderBelow()}</div>
      ) : (
        ''
      )}
    </div>
  )
}
